/**
 *
 * @param {number} total : On the basis of cart total it generate bucket.
 * @definition
 * shipping charges generally are lower than 1000.
 * So we need smaller buckets for 1000 to get more understanding of user behavior on cart
 * @returns {number} bucketsize
*/
export const getBucketSize = (total: number) => {
    if (total > 1000) {
        const quotient = Math.floor(total / 500);
        return quotient * 500;
    } else {
        const quotient = Math.floor(total / 50);
        return quotient * 50;
    }
};
